import * as React from "react";
// import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

const MerchPage = () => {
	return (
		<Layout>
			<Seo title="Now" />
			<h2>Now</h2>
			<div className="main--centerwrapper">
				<StaticImage
					src="../images/photos/pressRes/Jesse_Rivest_Toadstool_007.jpg"
					alt="Jesse Rivest press image"
					placeholder="blurred"
					layout="constrained"
					className="main--centered"
					imgClassName="img--bordered-small"
					width={500}
				/>
			</div>

			<h3>What am I doing now?</h3>
			<p>
				Updated <span id="updateDate">October 9, 2026</span>, from a sunny day after some refreshing rainy days.<br />
				(This is a <span className="italic">now page</span> in the style of Derek Sivers.)
			</p>

			<h4>Looking for a new apartment and studio</h4>
			<p>
				It turns out the owners of our apartment would like it back;
				they said their son would like to live in it.
				That's not surprising: In recent years I've heard often that younger folks are
				needing family assistance to make it out there in the world.
				So, we are starting to look for our next place, but I have to say: We really like living where we live.
				We were drawn to this area well before we moved here;
				we're just trying to organize our priorities to see how much weight will go toward staying in the area.
				I wonder what my next studio will sound like? How big will it be?
				How difficult will it be for me isolate it from the outside world (sound)?
				We shall see.
			</p>

			<h4>Getting ready for a trip home to Kelowna</h4>
			<p>
				I've got most of our tickets already, and we're excited for the trip ahead.
				It won't be a musical trip, i.e., no shows planned, rather one focusing on friends and family...
				and foods that we miss.
			</p>

			<h4>Letting go of my repertoire</h4>
			<p>
				For so many years, I've tried to keep my song repertoire "under my fingers", ready to go.
				That just doesn't make sense any more, as it eats up a significant amount of time,
				and since I really don't have a lot of opportunities to perform.
				I'm so slow at realizing things sometimes:
				It's better for me to stop acting like a touring artist and just focus on producing/recording.
				I have zero momentum for performing/touring and can't fill any seats;
				I love producing recordings and writing songs, so...
				I'm just gonna focus on that now and for now, until I don't know when.
				Every other week or so, I revisit a song from said repertoire and make a quick reminder video of how I play it on guitar;
				I'm focusing on more recent additions that have trickier bits;
				all this is to make it faster to recall how to perform a song, should the future have that in store for me.
			</p>

			<h4>Demoing and blueprinting songs for an album</h4>
			<p>
				I have a bunch of songs I wrote during the COVID pandemic that deserve some consideration.
				I started a songwriting challenge in 2020 which was:
				every day for 30 days, spend 30 minutes capturing an idea for a song.
				After that—in 2020 and 2021—I then went through nearly all of them and turned them into fully written songs;
				I made rough recordings (guitar, voice) to establish them.
				I have ever since then referred to these songs as my <span className="italic">Challenge</span> songs when talking with my partner, Jane.
				I reckon I should be able to get an LP for digital release out of these songs.
				I've so far demoed or blueprinted six of them, and have only 13 to go (the remaining 11 are deemed not considerable);
				I have a couple big (aforementioned) interruptions ahead, but I otherwise plan to continue working on them weekly.
				Even if I am in between studios, I can still work on them; I don't need studio sound for this work.
				I mean, a demo works better with studio sound, but a blueprint doesn't need that;
				a blueprint to me is focused simply on: tempo, key, feel and rhythm, song length, variation, and arrangement ideas.
				I can use a MIDI keyboard and a guitar in any room to accomplish pretty much all of that.
			</p>

			<h4>Reading</h4>
			<p>
				I'm <span className="bold">still</span> reading <span className="italic">David Copperfield</span> (Dickens).
				I devoured Mike Campbell's <span className="italic">Heartbreaker</span> memoir.
				There were parts of his musical life that reflected my own:
				Mom somehow getting me my first guitar when I was 16—Mike was the same age and seemingly even poorer than I was;
				Mike tending to lean throughout his life toward the humbler,
				coming-to-realize understanding of his musical worth—I haven't had the success or connections that he's had,
				but I certainly feel that my own road toward self understanding and self image has been like his.
			</p>

			<h4>Watching</h4>
			<p>
				The most recent film I watched, I ended up watching twice: <span className="italic">Blind Willow, Sleeping Woman</span>;
				directed and cowritten by Pierre Földes; Haruki Murakami gets a cowrite credit likely since the movie is based on his short stories.
				I am sure I've not read these short stories; as a film standing on its own, though, I felt quite moved.
				The film, though animated and fantastic, also felt very emotionally real.
				I didn't closely relate to any of the characters, but I felt like I understood their lives.
				Mostly, I just felt tickled by the uniqueness of the film; I can't say I've seen one quite like it.
			</p>

			<h4>Listening</h4>
			<p>
				Recently I've been loving the new album, <span className="italic">I Must Be Dreaming</span>, from Alabama Shakes,
				as well as <span className="italic">The Lemoine Point</span>, from Blind Yeo;
				the past few days, however, I've been diving into the lushness of Beck's latest album, <span className="italic">Ride Lonesome</span>.
			</p>


		</Layout>
	);
}

export default MerchPage;
